import React from "react";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "../../../shadcn/components/ui/input-otp";

interface OtpInputProps {
  otp: string;
  onChange: (value: string) => void;
}

export default function OtpInput({ otp, onChange }: OtpInputProps) {
  return (
    <InputOTP value={otp} onChange={onChange} maxLength={6}>
      <InputOTPGroup className="w-full gap-x-2 sm:gap-x-6 lg:gap-x-8 justify-left">
        <InputOTPSlot
          index={0}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
        <InputOTPSlot
          index={1}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
        <InputOTPSlot
          index={2}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
        <InputOTPSlot
          index={3}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
        <InputOTPSlot
          index={4}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
        <InputOTPSlot
          index={5}
          className="h-[50px] w-10 sm:w-11 lg:w-12 bg-white border border-gray-200 rounded-md"
        />
      </InputOTPGroup>
    </InputOTP>
  );
}

